<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
      <v-data-table :headers="headers" :items="dashboardinternaltransfers" :loading="isIntxLoading" :items-per-page="4"
        hide-default-footer disable-sort>
        <template v-slot:loading>
          <div class="d-flex align-center justify-center pa-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <span class="ml-2">Loading data...</span>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-information</v-icon>
            <span class="ml-2">No data found</span>
          </div>
        </template>
        <template v-slot:item.admin_name="{ item }">
          {{ item?.admin_name || "N/A" }}
        </template>
        <template v-slot:no-results>
          <div class="d-flex align-center justify-center pa-4">
            <v-icon color="secondary">mdi-magnify</v-icon>
            <span class="ml-2">No matching data found</span>
          </div>
        </template>
        <template v-slot:item.account_fullname="{ item }">
          <router-link v-if="$canRoute('internal-transctions') === 1" class="text-capitalize text--ash"
            :to="`/registered-user-details/${item?.client_account_id}`">
            {{ item.account_fullname }}
          </router-link>
          <span v-else class="text-capitalize text--ash">{{ item.account_fullname }}</span>
        </template>
        <template v-slot:item.trx_type="{ item }">
          <div class="d-flex align-items-center">
            <v-icon color="#B4C2D1" small :class="verifyIcon(item.trx_type)"></v-icon>
            <span>{{ item.trx_type }}</span>
          </div>
        </template>
        <template v-slot:item.account_email="{ item }">
          <v-tooltip top color="#000">
            <template v-slot:activator="{ on }">
              <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                {{ obfuscateAnyEmail(item?.account_email) }}
                <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                  {{
                    copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{ item?.account_email }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.status="{ item }">
          <div class="status-selection">
            <v-select solo :items="updateslots"
              :append-icon="item.status === 1 ? 'mdi-checkbox-marked-circle' : item.status === 2 ? 'mdi-cancel' : 'mdi-chevron-down'"
              class="custom-select" v-model="item.status" item-text="statusText" item-value="status"
              :disabled="item.status > 0" @change="onUpdateChange(item)">
              <template v-slot:selection="{ item }">
                <div :class="getTextColor(item)">
                  {{
                    item.status === 0
                      ? "Pending"
                      : item.status === 1
                        ? "Approved"
                        : item.status === 2
                          ? "Rejected"
                          : null
                  }}
                </div>
              </template>
            </v-select>
          </div>
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTIONS__ACTIONS } from "@/store/action-types";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      slots: ["All", "Pending", "Approved", "Rejected"],
      updateslots: [
        { status: 0, statusText: "Pending" },
        { status: 1, statusText: "Approve" },
        { status: 2, statusText: "Reject" },
      ],
      selectedStatus: null,
      modal: false,
      dialog: false,
      headers: [
        { text: "Date and Time", value: "created_at" },
        { text: "Name", value: "account_fullname" },
        { text: "Email", value: "account_email" },
        { text: "From Account", value: "from_account" },
        { text: "To Account", value: "trading_account_no" },
        { text: "Action By", value: "admin_name" },
        { text: "Status", value: "status" },
        { text: "Amount", value: "amount" },
      ],
      selectedDates: [],
      selectedDatesText: null,
      page: 1,
      itemsPerPage: 5,
      pageCount: 0,
      customItemsPerPageOptions: [5, 20, 50, 100],
      isCopied: false,
      copiedStates: {},
      methodName: null,
      showRejectionCauseSection: false,
      selectedFile: null,
      reason: null,
      remarks: null,
      showButtons: true,
      selectedReason: null,
      detailsDialog: {},
    };
  },
  computed: {
    ...mapState("trxinternal", ["dashboardinternaltransfers", "isIntxLoading"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("trxinternal", [
      TRANSACTIONS__ACTIONS.TRXDASHBOARDINTERNALTRANSFER,
      TRANSACTIONS__ACTIONS.UPDATEDEPOSIT,
    ]),

    onUpdateChange(item) {
      let parameter = {
        id: item?.id,
        status: item.status,
      };
      this[TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](parameter);
    },

    getTextColor(item) {
      return item.status === 1
        ? "text-approved"
        : item.status === 2
          ? "text-decline"
          : "text-pending";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText(item) {
      navigator.clipboard.writeText(item?.account_email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
  },

  async created() {
    await this[TRANSACTIONS__ACTIONS.TRXDASHBOARDINTERNALTRANSFER]();
  },
};
</script>
